axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            if (window.addiesaas.spa.instances[0].$store.getters.authCheck) {
                window.addiesaas.spa.instances[0].$store.dispatch('logout')
                window.location.reload()
            }
        }

        return Promise.reject(error)
    }
)

axios.defaults.baseURL = window.addiesaas.config.baseUri
